import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import {apiService} from '../../common/apiCallService';
import Loading from '../../Loading.js';
import {baseUrl} from '../../common/config.js';
import Menu from '../Menu.js'
import { Redirect } from 'react-router';
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import moment from 'moment';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';

class AppUserList extends Component {

  constructor(props) {
    super(props)
    this.state = {
        // usersList: props.usersList,
        loginRedirect: false,
        loading: false,
        activePage: 1,
        currColumn: 'first_name',
        msg:"",
        open: false,
        actions:[<FlatButton label="Ok" primary={true} keyboardFocused={true} onClick={this.handleClose}/>]
      }
  }

  // componentWillReceiveProps(nextProps) {
  //   if(nextProps.serachFlag){
  //     this.setState({
  //       activePage:1,
  //       offset:0
  //     })
  //   }
  //   this.setState({
  //     usersList: nextProps.usersList,
  //     totalCount: nextProps.totalCount,
  //     loading: false
  //   })
  // }

  // sorting = (column) =>{
  //   this.setState({loading: true})
  //     if(column == this.state.currColumn) {
  //       if(this.state.sortBy == 'asc') this.state.sortBy = 'desc'
  //       else this.state.sortBy = 'asc'
  //     } else {
  //       this.state.sortBy = 'asc'
  //     }
  //     this.state.currColumn = column
  //     this.props.setCurrentcolumn(this.state.sortBy,this.state.currColumn)
  // }

  onPaginate = (pageNumber) => {
     this.props.onPaginate(pageNumber);
     this.props.getUsersList();
  }

  onSort = (column) => {
    if(column === this.props.currColumn) {
      if(this.props.sortBy == 'asc') this.props.onSort(column, 'desc');
      else this.props.onSort(column, 'asc');
    } else {
      this.props.onSort(column, 'asc');
    }
    this.props.getUsersList();
  }
  deleteUser = (id) => {
    this.setState({msg: 'Are you sure you want to delete user ?'})
    this.setState({actions:[<FlatButton label="Ok" primary={true} keyboardFocused={true} onClick={()=>this.closeDilog(id)}/>,<FlatButton label="cancel" primary={true} onClick={()=>this.setState({open: false})}/>]})
    this.setState({open: true})

    // let confirmDelete = confirm("Are you Sure?")
    // if(!confirmDelete) return
    // this.setState({loading: true})
    // apiService(baseUrl + '/appUser/deletePlayer', {_id: id},  (data) => {
    //     this.setState({open: true})
        // this.setState({msg: data.msg})
    // }, (data) => {
    //     this.setState({open: true})
    //     this.setState({msg: data.msg})
    //     this.setState({loading: false})
    //     if(data.status == 403) {
    //       this.props.setLogin()
    //     }
    // })
  }
  closeDilog = (id) =>{
    this.setState({loading: true})
    this.state.open = false
    this.forceUpdate()

    apiService(baseUrl + '/appUser/deletePlayer', {_id: id},  (data) => {
        // this.state.open = true
        // this.forceUpdate();
        this.setState({loading: false})
        // window.location.reload();
        this.props.getUsersList();
        // this.setState({msg: data.msg})
        // this.setState({actions:[<FlatButton label="Ok" primary={true} keyboardFocused={true} onClick={this.handleClose}/>]})
    }
    // , (data) => {
    //     // this.setState({msg: data.msg})
    //     // this.setState({actions:[<FlatButton label="Ok" primary={true} keyboardFocused={true} onClick={this.handleClose}/>]})
    //     // this.setState({open: true})
    //     this.setState({loading: false})
    //     window.location.reload();
    //     // this.props.onPaginate('1',this.state.activePage,this.state.offset);
    //     if(data.status == 403) {
    //       this.props.setLogin()
    //     }
    // }
    )
  }
  handleClose = () => {
     this.setState({open: false});
     this.setState({loading: false})
     this.state.activePage = 1
     this.state.offset = 0
     this.forceUpdate()
     this.props.onPaginate('1',this.state.activePage,this.state.offset);
   };

  render() {

    return (
      <div >
        {this.state.loginRedirect && (<Redirect to={'/'}/>)}
        {this.state.open
          ?<Dialog
            actions={this.state.actions}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
          >
          {this.state.msg}
          </Dialog>
          :null}
        <div className="container">
          {this.props.totalCount == 0
            ?<div>
              <h5 style={{color:'white'}}><center>No Data Available For Given Search</center></h5>
             </div>
           :
           <div>
            <Paper zDepth={1} rounded={false} className="resp-paper" style={{marginLeft:'0px',marginRight:'0px'}}>
              <table className="resp-table resp-table-background"  style={{backgroundColor: "rgb(48, 48, 48)"}}>
                <thead className="resp-table-head">
                  <tr className="resp-table-tr">
                    <th  onTouchTap={() =>  this.onSort('first_name')} className="resp-table-th">First Name&nbsp;
                      <i className="fa fa-sort " data-e2e="sortfirstnameup"></i>
                    </th>
                    <th  onTouchTap={() => this.onSort( 'last_name')} className="resp-table-th">Last Name&nbsp;
                      <i className="fa fa-sort "data-e2e="sortlastname"></i>
                    </th>
                    <th className="resp-table-th">Role
                    </th>
                    <th className="resp-table-th">Business
                    </th>
                    <th  onTouchTap={() => this.onSort('status')} className="resp-table-th">Status&nbsp;
                      <i className="fa fa-sort "data-e2e="sortuserstatus"></i>
                    </th>
                    <th  onTouchTap={() => this.onSort('Created_date')} className="resp-table-th">Created_date&nbsp;
                      <i className="fa fa-sort "data-e2e="sortuserscreatedate"></i>
                    </th>
                    <th  className="resp-table-th">
                    </th>
                    <th  className="resp-table-th">
                    </th>
                  </tr>
                </thead>
                <tbody className="resp-table-body" data-e2e="userDataTable">
                  {this.props.usersList.map((item, key) => {
                       return (
                         <tr key={key} className="resp-table-tr">
                           <td className="UserList resp-table-td">{item.first_name}</td>
                           <td className="UserList resp-table-td">{item.last_name}</td>
                           <td className="UserList resp-table-td">{item.appRole.map(role => role.authority).join(' | ')}</td>
                           <td className="UserList resp-table-td">{item.business.map(buss => buss.business_name).join(' | ')}</td>
                           <td className="UserList resp-table-td">{item.status}</td>
                           <td className="UserList resp-table-td">{moment(item.Created_date).format("YYYY-MM-DD HH:mm:ss")}</td>
                           <td className="UserList resp-table-td" style={{padding: '0px'}}>
                             <Link  style={{textDecoration:"none"}}  to={'/editAppUser/'+item._id}>
                             <IconButton iconClassName="fa fa-edit"  data-e2e="user-edit"/>
                           </Link>
                           </td>
                           <td className="UserList resp-table-td" style={{padding: '0px'}} onTouchTap={()=>this.deleteUser(item._id)} >
                             <IconButton iconClassName="fa fa-trash-o" data-e2e="userremove"/>
                           </td>
                         </tr>
                       )
                   })}
                </tbody>
              </table>
            </Paper>
            <div>
              {this.props.totalCount > 10
              ?<div style={{textAlign: "center"}}>
                <Pagination prevPageText='Prev'
                  nextPageText='Next'
                  firstPageText='First'
                  lastPageText='Last'
                  activePage={this.props.pageNo}
                  itemsCountPerPage={this.props.max}
                  totalItemsCount={this.props.totalCount}
                  pageRangeDisplayed={5}
                  onChange={this.onPaginate}/>
              </div>
              : null}
            </div>
           </div>
         }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    pageNo: state.appUser.pageNo,
    currColumn: state.appUser.currColumn,
    sortBy: state.appUser.sortBy
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onPaginate: pageNo => dispatch(actions.onPaginate(pageNo)),
    getUsersList: () => dispatch(actions.getUsersList()),
    onSort: (column, name) => dispatch(actions.onSort(column, name))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AppUserList);



/** WEBPACK FOOTER **
 ** ./src/components/NewAppUser/AppUserList.js
 **/